module.exports = __webpack_public_path__ + "img/icon-camera-reverse.edaa0dda.svg";